import { render, staticRenderFns } from "./PlanVenteTree.vue?vue&type=template&id=20a55815&scoped=true&"
import script from "./PlanVenteTree.vue?vue&type=script&lang=js&"
export * from "./PlanVenteTree.vue?vue&type=script&lang=js&"
import style0 from "./PlanVenteTree.vue?vue&type=style&index=0&id=20a55815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a55815",
  null
  
)

component.options.__file = "PlanVenteTree.vue"
export default component.exports